import { computed, onUnmounted, ref } from 'vue'

export function followAmountError(entries, balance) {
  const pending = entries.filter((entry) => !entry.done)
  if (!pending.length) return '没有待跟投的注单'
  let cents = 0
  for (const entry of pending) {
    const value = String(entry.amount).trim()
    if (!/^\d+(\.\d{1,2})?$/.test(value) || Number(value) <= 0 || !Number.isSafeInteger(Math.round(Number(value) * 100))) {
      return '请输入大于 0 的金额，最多两位小数'
    }
    cents += Math.round(Number(value) * 100)
  }
  if (!Number.isFinite(Number(balance)) || cents > Math.round(Number(balance) * 100)) return '跟投金额不能超过可用余额'
  return ''
}

// Each page supplies its original API mapping; the dialog never changes the selected plays.
export function useChatFollowBet({ balance, allowed, send, single = false, afterSuccess }) {
  const target = ref(null)
  const busy = ref(false)
  const error = ref('')
  const toast = ref('')
  let toastTimer
  const validation = computed(() => {
    if (!target.value) return ''
    if (!target.value.entries.length || target.value.entries.some((entry) => !entry.playId)) return '下注内容已失效，请刷新后重试'
    if (!allowed(target.value)) return '该注单已封盘、已取消或期号已变更，无法跟投'
    return followAmountError(target.value.entries, balance.value)
  })
  function open(details) {
    if (busy.value) return
    error.value = ''
    toast.value = ''
    target.value = {
      ...details,
      entries: details.entries.map((entry) => ({ ...entry, original: Number(entry.amount), amount: Number(entry.amount).toFixed(2), done: false })),
    }
  }
  function close() { if (!busy.value) target.value = null }
  async function confirm() {
    if (busy.value || !target.value) return
    error.value = ''
    if (validation.value) return
    busy.value = true
    const current = target.value
    try {
      const pending = current.entries.filter((entry) => !entry.done)
      if (single) {
        for (const entry of pending) {
          if (!allowed(current)) throw new Error('该注单已封盘、已取消或期号已变更')
          await send([entry], current)
          // Do not resend accepted rows if a later row fails.
          entry.done = true
        }
      } else {
        await send(pending, current)
        pending.forEach((entry) => { entry.done = true })
      }
      target.value = null
      toast.value = '跟投成功'
      clearTimeout(toastTimer)
      toastTimer = setTimeout(() => { toast.value = '' }, 2500)
    } catch (failure) {
      const done = current.entries.filter((entry) => entry.done).length
      error.value = `${done ? `已成功 ${done} 注；` : ''}${failure.message || '跟投失败'}`
    } finally {
      busy.value = false
      // Refresh errors must never turn an accepted bet into a retryable failure.
      if (current.entries.some((entry) => entry.done)) {
        void Promise.resolve().then(() => afterSuccess?.()).catch(() => {})
      }
    }
  }
  onUnmounted(() => clearTimeout(toastTimer))
  return { target, busy, error, toast, validation, open, close, confirm }
}
